module.exports = __webpack_public_path__ + "static/can_logo_white-83055af3ada73abd2709f4144a7c79bb.png";